export var SET_PLAYING = 'viewer/SET_PLAYING';
export var SET_CURRENT_DATE = 'viewer/SET_CURRENT_DATE';
export var SET_CURRENT_CAMERA_POSITION = 'viewer/SET_CURRENT_CAMERA_POSITION';
export var SET_CURRENT_SCENARIO_SECONDS_PER_TICK = 'viewer/SET_CURRENT_SCENARIO_SECONDS_PER_TICK';
export var GET_CURRENT_SCENARIO_SECONDS_PER_TICK = 'viewer/GET_CURRENT_SCENARIO_SECONDS_PER_TICK';
